import type { RouteRecordRaw } from 'vue-router'

const SuppliersPage = () => import('./pages/SuppliersPage.vue')

const procurementRoutes: RouteRecordRaw[] = [
  {
    name: 'procurement-suppliers',
    path: 'suppliers',
    component: SuppliersPage,
    meta: { requiresAuth: true },
  },
]

export default procurementRoutes
